(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets/assets/javascripts/play/utils/ticket-listener.js') >= 0) return;  svs.modules.push('/modules/tickets/assets/javascripts/play/utils/ticket-listener.js');
"use strict";


setGlobal('svs.tickets.play.utils.TicketListener', () => {
  let paused = false;
  let pausedEvents = [];
  const listener = (eventName, eventData) => {
    if (paused) {
      pausedEvents.push({
        eventName,
        eventData
      });
      return;
    }
    dispatchEvent(new CustomEvent(eventName, {
      detail: eventData
    }));
  };
  const setPaused = isPaused => {
    paused = isPaused;
    if (!paused) {
      pausedEvents.forEach(_ref => {
        let {
          eventName,
          eventData
        } = _ref;
        dispatchEvent(new CustomEvent(eventName, {
          detail: eventData
        }));
      });
      pausedEvents = [];
    }
  };
  return {
    listener,
    setPaused
  };
});

 })(window);